import { Button, ButtonTypes, Spinner, TextBox } from "@repo/ui";
import { Plus, Save } from "lucide-react";

import style from "./style.module.scss";

interface ConfigEditorProps {
	name: string;
	onNameChange: (name: string) => void;
	onSave: () => void;
	onCancel: () => void;
	isNew: boolean;
	isSaving?: boolean;
}

export function ConfigEditor(props: ConfigEditorProps) {
	const { name, onNameChange, onSave, onCancel, isNew, isSaving } = props;

	return (
		<div className={style.editor}>
			<div className={style.editorFields}>
				<TextBox label="Configuration Name" value={name} changeHandler={onNameChange} />
			</div>

			<div className={style.editorActions}>
				<Button
					types={[ButtonTypes.Primary]}
					onClick={onSave}
					disabled={!name.trim() || isSaving}
					fullWidth
					className={style.editorButton}
				>
					{isSaving ? (
						<Spinner size={16} className={style.editorButtonIcon} />
					) : isNew ? (
						<Plus className={style.editorButtonIcon} />
					) : (
						<Save className={style.editorButtonIcon} />
					)}
					{isNew ? "Create" : "Save"}
				</Button>
				<Button types={[ButtonTypes.Outline]} onClick={onCancel} fullWidth className={style.editorButton}>
					Cancel
				</Button>
			</div>
		</div>
	);
}
